// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__1s0X7","productName":"Table_productName__D35Bx"};